import React, { useEffect } from "react";
import { Field, FieldArrayRenderProps } from "@progress/kendo-react-form";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { Button } from "@progress/kendo-react-buttons";
import AppDialog, { DialogCloseButton } from "../../components/dialog/Dialog";
import { Typography } from "@progress/kendo-react-common";
import FormNumericTextField from "../../components/formFields/FormNumericTextField";
// import FormIncrementalSearch from "../../components/formFields/FormIncrementalSearch";
import {
  //   setContraBillDialogOpenIndex,
  setContraEntryDeleteIndex,
} from "./contraSlice";
// import { getAllOutstandingContra } from "./services/contra.services";
// import { useLocation } from "react-router-dom";
import {
  requiredValidator,
  skipValidator,
} from "../../components/formFields/CommonValidator";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { formatIndianNumber } from "../../_helper/helper";
import { PAYMENT_INITIAL } from "../../_contstants/common";
import FormTextField from "../../components/formFields/FormTextField";

const ContraEntryDetailsArray = (
  fieldArrayRenderProps: FieldArrayRenderProps
) => {
  const dispatch = useAppDispatch();
  //   const location = useLocation();
  //   const contra_guid = location.state?.contra_guid;
  const ContraEntryDeleteIndex = useAppSelector(
    (state) => state.contra.ContraEntryDeleteIndex
  );
  const AccountPaymentAndReceiptList = useAppSelector(
    (state) => state.account.AccountPaymentAndReceiptList
  );

  const InputRef = React.useRef<any>(null);
  const dialogName = useAppSelector((state) => state.dialog.dialogName);

  const handleDeleteAction = React.useCallback(
    async (index: number) => {
      fieldArrayRenderProps.onRemove({ index: index });
      dispatch(closeDialog());
      dispatch(setContraEntryDeleteIndex(-1));
      const element = document.getElementsByName(
        `contra_entry.${index - 1}.amount`
      );
      if (element?.[0]) {
        element?.[0]?.focus();
      }
    },
    [fieldArrayRenderProps]
  );

  const pushElementInarrayFirst = React.useCallback(() => {
    fieldArrayRenderProps.onPush({
      value: {
        debit_credit: "Credit",
        ledger_id: "",
        amount: null,
        cheque_no: null,
        bank_name: "HARIHAR FOODS PVT LTD",
        // contra_entry_referance: [],
      },
    });

    // setTimeout(() => {
    //   InputRef.current?.element?.children[0]?.children[1]?.children[0]?.focus();
    // }, 0);
  }, [fieldArrayRenderProps]);

  useEffect(() => {
    if (fieldArrayRenderProps.value?.length === 0) {
      pushElementInarrayFirst();
    }
  }, []);
  //   const handleSearchLedger = (search: any, index: any) => {
  //     if (search) {
  //       fieldArrayRenderProps.handleVendorSearchChange(
  //         search,
  //         `contra_entry.${index}.ledger_options`,
  //         fieldArrayRenderProps.formRenderProps
  //       );
  //     }
  //   };

  const handleChange = (index: number, fieldArrayRenderProps: any) => {
    // fieldArrayRenderProps.formRenderProps.onChange(
    //   `contra_entry.${index}.contra_entry_referance`,
    //   {
    //     value: [],
    //   }
    // );
    const debit_credit = fieldArrayRenderProps.formRenderProps.valueGetter(
      `contra_entry.${index}.debit_credit`
    );

    if (debit_credit === "Debit") {
      fieldArrayRenderProps.formRenderProps.onChange(
        `contra_entry.${index}.amount`,
        {
          value: null,
        }
      );
    }

    // dispatch(setContraBillDialogOpenIndex(-1));
  };
  const handleKeyEvent = (
    e: any,
    index: number,
    fieldArrayRenderProps: FieldArrayRenderProps
  ) => {
    const value = parseFloat(e?.target?.value?.replace(/,/g, ""));
    if (
      e.key === "Tab" &&
      value &&
      fieldArrayRenderProps.value[index].ledger_id
    ) {
      if (!e.shiftKey) {
        // const payloadFindBill = {
        //   contra_guid: contra_guid ? contra_guid : null,
        //   credit_or_debit: "DB",
        //   ledger_id: fieldArrayRenderProps.value[index].ledger_id,
        // };
        const fetchBillList = async () => {
          //   const IsContraRefID =
          //     fieldArrayRenderProps.value[index].contra_entry_referance?.[0]
          //       ?.contra_ref_id;
          //   if (
          //     fieldArrayRenderProps.value[index].contra_entry_referance.length >
          //       0 &&
          //     !IsContraRefID
          //   ) {
          // dispatch(setContraBillDialogOpenIndex(index));
          dispatch(openDialog("BillItemDeleteDialog"));
          //   }
          //   else {
          //     const response = await dispatch(
          //       getAllOutstandingContra(payloadFindBill)
          //     );
          //     if (response.meta.requestStatus === "fulfilled") {
          //       dispatch(openDialog("BillItemDeleteDialog"));
          //       //   dispatch(setContraBillDialogOpenIndex(index));
          //     }
          //   }
        };
        fetchBillList();
        if (fieldArrayRenderProps.value.length === index + 1) {
          pushElementInarrayFirst();
        }
      }
    }
    if (
      e.key === "Escape" &&
      fieldArrayRenderProps.value.length !== 1 &&
      index !== 0
    ) {
      dispatch(openDialog("ContraItemDeleteDialog"));
      dispatch(setContraEntryDeleteIndex(index));
    }
  };

  const handleViewAccount = (
    index: number,
    fieldArrayRenderProps: FieldArrayRenderProps
  ) => {
    const account_guid =
      (AccountPaymentAndReceiptList &&
        AccountPaymentAndReceiptList?.length > 0 &&
        AccountPaymentAndReceiptList?.find(
          (item: any) =>
            item.id === fieldArrayRenderProps.value[index]?.ledger_id
        )?.account_guid) ||
      "";
    window.open(`/account/edit/${account_guid}`);
  };

  return (
    <>
      <GridLayout cols={[{ width: "100%" }]}>
        <GridLayoutItem className="bg-dark text-white fw-600">
          <GridLayout
            style={{
              padding: 10,
              marginRight: 15,
            }}
            gap={{ rows: 10, cols: 5 }}
            cols={[
              { width: "12%" },
              { width: "40%" },
              { width: "29%" },
              { width: "19%" },
            ]}
          >
            <GridLayoutItem>Initial</GridLayoutItem>
            <GridLayoutItem>Ledger Name</GridLayoutItem>
            <GridLayoutItem></GridLayoutItem>
            <GridLayoutItem style={{ textAlign: "end", marginRight: "10px" }}>
              Amount
            </GridLayoutItem>
          </GridLayout>
        </GridLayoutItem>

        {dialogName === "ContraItemDeleteDialog" && (
          <AppDialog>
            <>
              <Typography.h5>{"Delete Item"}</Typography.h5>
              <GridLayout>
                <GridLayoutItem>
                  <Typography.p>
                    Are you sure you want to delete this?
                  </Typography.p>
                </GridLayoutItem>
                <GridLayoutItem
                  style={{
                    display: "flex",
                    justifyContent: "end",
                  }}
                >
                  <Button
                    fillMode={"solid"}
                    themeColor={"error"}
                    onClick={() => handleDeleteAction(ContraEntryDeleteIndex)}
                    type="button"
                    style={{ marginRight: 5 }}
                  >
                    Delete
                  </Button>
                  <DialogCloseButton themeColor="error" />
                </GridLayoutItem>
              </GridLayout>
            </>
          </AppDialog>
        )}
        {fieldArrayRenderProps.value &&
          fieldArrayRenderProps.value.length > 0 &&
          fieldArrayRenderProps.value.map(
            (contra_entry: any, index: number) => (
              <>
                <GridLayoutItem key={index}>
                  <GridLayout
                    style={{
                      marginRight: 10,
                      padding: 15,
                    }}
                    gap={{ rows: 10, cols: 5 }}
                    cols={[
                      { width: "12%" },
                      { width: "40%" },
                      { width: "29%" },
                      { width: "19%" },
                    ]}
                  >
                    <GridLayoutItem>
                      <Field
                        // wrapperClassName="right-alighned-field"
                        wrapperStyle={{ margin: 0 }}
                        name={`contra_entry.${index}.debit_credit`}
                        id={`contra_entry.${index}.debit_credit_id`}
                        format="n2"
                        className="hide-clear-action"
                        component={FormSelectionField}
                        disabled={index === 0}
                        options={PAYMENT_INITIAL.map((init: any) => {
                          return {
                            value: init?.value,
                            label: init?.label,
                          };
                        })}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem ref={InputRef}>
                      <Field
                        wrapperStyle={{ margin: 0 }}
                        name={`contra_entry.${index}.ledger_id`}
                        placeholder="Search ledger"
                        id={`contra_entry.${index}.ledger_id_id`}
                        // component={FormIncrementalSearch}
                        component={FormSelectionField}
                        onChange={() =>
                          handleChange(index, fieldArrayRenderProps)
                        }
                        // fetchIncrementalData={(search: any) =>
                        //   handleSearchLedger(search, index)
                        // }
                        validator={
                          fieldArrayRenderProps?.value[index]?.amount
                            ? requiredValidator
                            : skipValidator
                        }
                        // options={
                        //   fieldArrayRenderProps.value[
                        //     index
                        //   ]?.ledger_options?.map((item: any) => {
                        //     return {
                        //       value: item?.id,
                        //       label: item?.account_name,
                        //     };
                        //   }) || []
                        // }
                        options={
                          AccountPaymentAndReceiptList?.map((ledger: any) => {
                            return {
                              value: ledger?.id,
                              label: ledger?.account_name,
                            };
                          }) || []
                        }
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      {fieldArrayRenderProps?.value[index]?.ledger_id && (
                        <Button
                          type="button"
                          fillMode={"solid"}
                          themeColor={"primary"}
                          style={{ marginLeft: 6 }}
                          onClick={() =>
                            handleViewAccount(index, fieldArrayRenderProps)
                          }
                        >
                          View
                        </Button>
                      )}
                    </GridLayoutItem>
                    <GridLayoutItem>
                      {/* {fieldArrayRenderProps.value[index]?.debit_credit ===
                      "Debit" && ( */}
                      <Field
                        wrapperClassName="right-alighned-field"
                        wrapperStyle={{ margin: 0 }}
                        name={`contra_entry.${index}.amount`}
                        placeholder="0"
                        format="n2"
                        component={FormNumericTextField}
                        onKeyDown={(e: any) =>
                          handleKeyEvent(e, index, fieldArrayRenderProps)
                        }
                      />
                      {/* )} */}
                    </GridLayoutItem>
                    {/* <GridLayoutItem>
                    {fieldArrayRenderProps.value[index]?.debit_credit ===
                      "Credit" && (
                      <Field
                        wrapperClassName="right-alighned-field"
                        wrapperStyle={{ margin: 0 }}
                        name={`contra_entry.${index}.amount`}
                        placeholder="0"
                        format="n2"
                        component={FormNumericTextField}
                        onKeyDown={(e: any) =>
                          handleKeyEvent(e, index, fieldArrayRenderProps)
                        }
                      />
                    )}
                  </GridLayoutItem> */}
                    <GridLayoutItem></GridLayoutItem>
                    <GridLayoutItem style={{ display: "flex", gap: "10px" }}>
                      <Field
                        wrapperClassName="w-50"
                        wrapperStyle={{ margin: 0 }}
                        name={`contra_entry.${index}.bank_name`}
                        placeholder="Favoring Name"
                        component={FormTextField}
                      />
                      <Field
                        wrapperClassName="w-50"
                        wrapperStyle={{ margin: 0 }}
                        name={`contra_entry.${index}.cheque_no`}
                        placeholder="Cheque No"
                        component={FormTextField}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem></GridLayoutItem>
                    <GridLayoutItem></GridLayoutItem>
                  </GridLayout>
                </GridLayoutItem>
                {/* {fieldArrayRenderProps.value?.[
                  index
                ]?.contra_entry_referance?.filter(
                  (pay_ref: any) => pay_ref?.referance_amount
                ).length > 0 && (
                  <GridLayoutItem>
                    <GridLayout
                      style={{
                        marginRight: 10,
                        padding: "0 30px",
                      }}
                      gap={{ rows: 5, cols: 5 }}
                    >
                      {fieldArrayRenderProps.value?.[
                        index
                      ]?.contra_entry_referance
                        ?.filter((pay_ref: any) => pay_ref?.referance_amount)
                        .map((item: any, ind: number) => (
                          <GridLayoutItem key={ind}>
                            <div>
                              <span
                                style={{
                                  fontWeight: "bold",
                                  width: "15px",
                                  display: "inline-block",
                                }}
                              >
                                {ind + 1}
                              </span>
                              <span
                                style={{
                                  fontWeight: "bold",
                                  marginLeft: "10px",
                                  background: "#e9e9e9",
                                  padding: "2px",
                                  width: "200px",
                                  display: "inline-block",
                                }}
                              >
                                {item?.bill_no_string
                                  ? item?.bill_no_string
                                  : item?.refernace_name}
                              </span>
                              <span
                                style={{
                                  marginLeft: "20px",
                                  fontWeight: "bold",
                                }}
                              >
                                {item?.referance_amount} Dr.
                              </span>
                            </div>
                          </GridLayoutItem>
                        ))}
                    </GridLayout>
                  </GridLayoutItem>
                )} */}

                <div
                  style={{
                    background: "goldenrod",
                    height: "1px",
                    opacity: "1",
                    margin: "10px 0",
                  }}
                />
              </>
            )
          )}

        <GridLayoutItem style={{ borderTop: "1px solid #ccc", marginTop: 10 }}>
          <GridLayout
            style={{
              marginRight: 10,
              padding: 10,
            }}
            gap={{ rows: 10, cols: 5 }}
            cols={[
              { width: "8%" },
              { width: "62%" },
              { width: "15%" },
              { width: "15%" },
            ]}
          >
            <GridLayoutItem colSpan={3}></GridLayoutItem>
            <GridLayoutItem>
              <h5
                style={{
                  textAlign: "end",
                  fontWeight: "bold",
                }}
              >
                {(Array.isArray(fieldArrayRenderProps?.value) &&
                  fieldArrayRenderProps?.value.length > 0 &&
                  formatIndianNumber(
                    fieldArrayRenderProps.value?.[0]?.db_total
                      ?.contra_total_amount
                  )) ||
                  0}
              </h5>
            </GridLayoutItem>
          </GridLayout>
        </GridLayoutItem>
      </GridLayout>
    </>
  );
};

export default ContraEntryDetailsArray;
